import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const LoginMutation = graphql(/* GraphQL */ `
  mutation login($loginInput: AccessInput!) {
    access(input: $loginInput) {
      ...AccessPayload
    }
  }
`);
